import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { GdprField } from "./gdprFields"
import { IGdprField } from "./gdprFields.types"
import { GetCallTraceAuditQuery } from "@/api/hasura/generated/graphql"
import { IContact } from "@/models/contacts/contact.types"

export type CallTraceAuditGdprType =
  "EMAIL" | "NAME" | "ADDRESS" | "PHONE" | "OTHER"

export type CallTraceAuditConfirmedStatus =
  "UNCONFIRMED" | "CONFIRMED" | "ALTERNATIVE" | "REJECTED"

export type CallTraceAuditResponse =
  GetCallTraceAuditQuery["call_trace_audit"][0]
const gdprTypeToContact: Partial<{
  [key in CallTraceAuditGdprType]: Partial<keyof IContact>
}> = {
  EMAIL: "email",
  PHONE: "phone1",
}

export const GdprFieldParser: IParser<IGdprField, CallTraceAuditResponse> = {
  toDomain: (data: CallTraceAuditResponse) => {
    try {
      return new GdprField(
        data.account_number,
        data.confirm_status,
        data.data_updated,
        gdprTypeToContact[data.gdpr_type],
        data.id,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
